<template>
    <v-snackbar
        :color="notification.class"
        multi-line
        v-model="snackbar"
        top
        :timeout="10000"
        data-cy="snackbarNotification"
    >
        <v-layout align-center pr-4>
            <v-icon class="pr-3" dark>{{ notification.icon }}</v-icon>
            <v-layout column>
                {{ notification.text }}
            </v-layout>
        </v-layout>

        <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">
                <v-icon dark> mdi-close </v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'alert-snackbar',
    computed: {
        ...mapGetters({
            notification: 'ui/notification',
        }),
        snackbar: {
            get() {
                return this.$store.getters['ui/notification'].display;
            },
            set() {
                this.$store.commit('ui/set_notification', {
                    display: false,
                });
            },
        },
    },
};
</script>
